<p-button
  [class]="sizeClass"
  [severity]="severity"
  [disabled]="disabled"
  [rounded]="rounded"
  [text]="textButton"
  [outlined]="outlinedButton"
  [icon]="iconOnlyButton ? icon : undefined"
  [styleClass]="styleClass"
  (onClick)="onClick.emit()"
>
  @if (!iconOnlyButton) {
    <div class="flex align-items-center gap-spacing-default">
      @if (iconStart) {
        <i
          style="font-size: var(--size-md)"
          [ngClass]="{ spin: isLoading }"
          [class]="iconStart + ' me-0'"
        ></i>
      }

      @if (label) {
        <span class="p-button-label">{{ label }}</span>
      }

      @if (iconEnd) {
        <i
          style="font-size: var(--size-md)"
          [class]="iconEnd + ' text-lg me-0'"
        ></i>
      }
    </div>
  }
</p-button>
